import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationService } from 'src/app/service/reservation.service';
import { PaymentService } from 'src/app/service/payment.service';
import { ReservationPayment } from 'src/app/model/reservation-payment';
import { Reservation } from 'src/app/model/reservation.model';import { AuthService } from 'src/app/service/auth.service';
import { MatTableDataSource } from '@angular/material';
import { TranslationService } from 'src/app/service/translate.service';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { DialogService } from 'src/app/service/dialog.service';
;

@Component({
  selector: 'app-paymentfinish',
  templateUrl: './payment-finish.component.html',
  styleUrls: ['./payment-finish.component.css']
})
export class PaymentFinishComponent implements OnInit {

  reservationPayment: ReservationPayment;
  reservation: Reservation;

  constructor(
    private activatedRoute: ActivatedRoute,
    private reservationService: ReservationService,
    private paymentService: PaymentService,
    private router: Router,
    private authService: AuthService,
    public translationService: TranslationService,
    private translationPipe: TranslationPipe,
    private dialogService: DialogService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      const paymentId = params.paymentId as string;
      if (paymentId !== '0') {
        this.paymentService.getPaymentById(paymentId).subscribe(res => {
          if (res) {
            this.reservationPayment = res as ReservationPayment;
            if (this.reservationPayment) {
              this.reservationService.getByIdWithOrderItems(this.reservationPayment.reservationId).subscribe(reservation => {
                this.reservation = reservation as Reservation;
              });
            }
          }
        });
      }
    });
  }

  get isPayed() {
    return this.reservationPayment && this.reservationPayment.tranReturnCode === '00';
  }

  goToHome() {
    if (this.authService.currentUserIsAdmin) {
      this.router.navigateByUrl('reservation-list');
    } else {
      this.router.navigateByUrl('profile');
    }
  }

  pay() {
    if (this.reservation != null) {
      this.paymentService.pay(this.reservation).subscribe(
        res => {
          window.location.href = res.hppUrl;
        },
        err => {
          this.dialogService.showMessage(
            this.translationPipe.transform('msgPaymentErrorTitle'),
            this.translationPipe.transform('msgPaymentError'));
        }
      );
    }
  }

}
